import React, { useMemo } from "react";
import { TableRowProps } from "../../types";

export const PrayerTableRow = React.memo(({
  prayer,
  HijraLocale,
  hijraLocale,
  show,
  renderCell,
  index,
  isToday
}: TableRowProps) => {
  const rowData = useMemo(
    () => [
      <>
        {prayer.currentDate}
        {HijraLocale.isActive && typeof hijraLocale === "function" && (
          <p>{hijraLocale(prayer.date)}</p>
        )}
      </>,
      prayer.fajr_begins,
      prayer.fajr_iqamah,
      prayer.sunrise,
      prayer.dhuhr_begins,
      prayer.dhuhr_iqamah,
      prayer.asr_begins,
      prayer.asr_iqamah,
      prayer.maghrib_begins,
      prayer.maghrib_iqamah,
      prayer.isha_begins,
      prayer.isha_iqamah,
      prayer.midnight,
      show ? prayer.midnight : null,
    ],
    [prayer, HijraLocale, hijraLocale, show]
  );

  return (
    <tr>
      {rowData.map((content, j) => {
        if (content !== null && content !== undefined) {
          return renderCell(content, `cell-${index}-${j}`, isToday);
        }
        return null;
      })}
    </tr>
  );
});